import { downloadExcel } from 'react-export-table-to-excel';
import { OrganizationChartNode } from '../../../system/organization_chart/OrganizationChartNode';
import { ICollaboratorDetailList } from '../../../system/panel/PanelSystem';

class ProjectTableExporter {
  private constructor(
      private comparisonData: ICollaboratorDetailList[],
      private fileName: string,
      private sheetName: string,
      private t: (key: string) => string
  ) {}

  static exportFor(
      comparisonData: ICollaboratorDetailList[],
      t: (key: string) => string,
      fileName: string = 'Datos proyectos',
      sheetName: string = 'proyectos',
  ) {
    const exporter = new this(comparisonData, fileName, sheetName, t);

    exporter.export();
  }

  export() {
    downloadExcel({
      fileName: this.fileName,
      sheet: this.sheetName,
      tablePayload: {
        header: this.getHeader(),
        body: this.getBody(),
      },
    });
  }

  private getBody() {
    console.log("valor de this.comparisonData", this.comparisonData);
    
    return this.comparisonData.map((item: any) => {

      return [item.pro_nombre, item.cant_actividades, item.participa, item.declina, item.tag_pending, item.horas_participa, item.horas_tag_pending, item.cant_docs];
    });
  }

  private getHeader() {
    return [
      this.t('Proyecto'),
      this.t('Actividades totales'),
      this.t('Actividades confirmadas'),
      this.t('Actividades declinadas'),
      this.t('Actividades pendientes'),
      this.t('Horas confirmadas'),
      this.t('Horas pendientes'),
      this.t('Documentos totales'),
    ];
  }
}

export default ProjectTableExporter;
